import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79248dad&scoped=true&"
import script from "./design-project.js?vue&type=script&lang=js&"
export * from "./design-project.js?vue&type=script&lang=js&"
import style0 from "./design-project.scss?vue&type=style&index=0&id=79248dad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79248dad",
  null
  
)

export default component.exports